import { loadStages, buildStageMaps } from "@/objects/stageLoader";

// HRDC taxPOD service. Single source of truth: the hrdc DB Stage table, served
// by /v1/en/console/stage/get-stages and cached client-side (see stageLoader).
const HRDC_API_URL = process.env.VUE_APP_SERVICE_URL_HRDC;

export default class HrdcData {
  constructor(apiUrl = HRDC_API_URL) {
    this.stagePriority = null;
    this.stageSlug = null;
    this.stageIndex = null;
    this.stageSlugToStageName = null;

    // `allStages` resolves to the STAGE_NAME -> id map; the four lookup maps
    // above are populated as a side effect once stages load. Consumers that need
    // the maps before first paint should `await this.allStages` first.
    this.allStages = loadStages("hrdc", apiUrl).then((stages) => {
      const maps = buildStageMaps(stages);
      this.stagePriority = maps.stagePriority;
      this.stageSlug = maps.stageSlug;
      this.stageIndex = maps.stageIndex;
      this.stageSlugToStageName = maps.stageSlugToStageName;
      return maps.allStage;
    });
  }
}
